export enum BonusTypes {
    Untyped = 'untyped',
    Item = 'item',
    Circumstance = 'circumstance',
    Status = 'status',
    Proficiency = 'proficiency',
}
